import type { Session } from "@/shared/auth/session";

/**
 * An **employee-only** membership (ADR-0023 decision 4, M19 plan §11 item 4): the read-only `employee`
 * preset, which holds no permission at all — so the web portal has nothing it may show them, and their
 * self-service is the mobile app's. The api says so itself on the membership (`employeeOnly`, S5-06);
 * the session's current membership is read for it. Should the marker be missing (an older api, or the
 * membership absent from the list), a role with an empty permission set — what makes it true — answers.
 * An Owner's `*` or any ticked permission is never employee-only, whatever else the membership is linked
 * to.
 */
export function isEmployeeOnlySession(
  session: Pick<Session, "permissions" | "memberships" | "tenant">,
): boolean {
  const marker: unknown = session.memberships.find((m) => m.tenantId === session.tenant.id)?.employeeOnly;
  if (typeof marker === "boolean") return marker;
  return Array.isArray(session.permissions) && session.permissions.length === 0;
}
